import { render, staticRenderFns } from "./EditProfileData.vue?vue&type=template&id=6f99c30f&scoped=true&"
import script from "./EditProfileData.vue?vue&type=script&lang=ts&"
export * from "./EditProfileData.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f99c30f",
  null
  
)

export default component.exports